var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('quill-editor',{ref:"quillEditor",attrs:{"options":{},"content":_vm.content},on:{"focus":function($event){return _vm.onEditorFocus($event)}}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }